module.exports = __webpack_public_path__ + "static/media/aparat.1013e4cd.png";